// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__24jt2","header":"MergedInvoice_header__1BPT_"};